module.exports = __webpack_public_path__ + "static/img/3041_phase_function_Paper_Points.e9aa3b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3041_phase_function_Paper_Points.png
// module id = dwmv
// module chunks = 0